module.exports = __webpack_public_path__ + "img/cloud-clock.80f4e316.svg";